module.exports = __webpack_public_path__ + "static/img/licm_track_0424.d0fab7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/licm_track_0424.jpg
// module id = 2Zo6
// module chunks = 1